import { withLinks } from './index';
export var decorators = [withLinks];